import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@material-ui/core";
import { get, getDatabase, ref, update } from "firebase/database";
import React from "react";
import { BeatLoader } from "react-spinners";
import useCurrentUser from "../../hooks/useCurrentUser";
import { userType } from "../Constraints";
const UpgradeItem = ({ upgrade, done }) => {
  const [loading, setLoading] = React.useState(false);
  const { loading: userLoading, user } = useCurrentUser(upgrade?.id);

  const updateMemberShip = async (memberType) => {
    if (upgrade.state !== "success") {
      setLoading(true);
      const db = getDatabase();
      const settingRef = ref(db, "Settings/");
      const snapshot = await get(settingRef);
      if (snapshot.exists()) {
        const setting = snapshot.val();
        const packagePrice = getPackegPrice(setting);
        const referBonous = parseFloat(setting?.referBonus);
        const referAmount = (packagePrice * referBonous) / 100;

        const usersRef = ref(db, "Users/");

        const referSnapshot = await get(usersRef);
        const users = [...Object.values(referSnapshot.val())];
        const referUsers = users.filter((user) => {
          return user?.myReferCode === upgrade?.referCode;
        });
        if (referUsers.length > 0) {
          const referUser = referUsers[0];
          const referNewBalance = parseFloat(referUser?.balance) + referAmount;
          update(ref(db, `Users/${referUser.phone}`), {
            balance: referNewBalance,
          })
            .then((result) => {
              const currentdate = new Date();
              const datetime =
                "" +
                currentdate.getDate() +
                "/" +
                (currentdate.getMonth() + 1) +
                "/" +
                currentdate.getFullYear() +
                " -- " +
                currentdate.getHours() +
                ":" +
                currentdate.getMinutes() +
                ":" +
                currentdate.getSeconds();
              //add earning history
              const earningHistory = {
                amount: referAmount,
                earnForm: "Refer New User",
                time: datetime,
              };
              update(
                ref(db, `EarningHistory/${referUser.phone}/${currentdate}`),
                earningHistory
              )
                .then((res) => {
                  updateUser(upgrade?.memberRequestType);
                })
                .catch((err) => {
                  setLoading(false);
                });
            })
            .catch((err) => {
              setLoading(false);
            });
        } else {
          updateUser(upgrade?.memberRequestType);
        }
      }
    } else {
      alert("Already Accepted.");
    }
  };

  const getPackegPrice = (setting) => {
    if (upgrade?.memberRequestType === "Silver") {
      return parseFloat(setting?.silverPrice);
    } else if (upgrade?.memberRequestType === "Platinum") {
      return parseFloat(setting?.platinumPrice);
    } else if (upgrade?.memberRequestType === "Gold") {
      return parseFloat(setting?.goldPrice);
    }
  };

  function updateUser(memberType) {
    const db = getDatabase();
    setLoading(true);
    update(ref(db, `Users/${upgrade.id}`), {
      memberType,
    })
      .then((res) => {
        update(ref(db, `UpgradeRequest/${upgrade.id}`), {
          state: "success",
        }).then((result) => {
          setLoading(false);
        });
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const cancelRequest = async () => {
    const db = getDatabase();
    setLoading(true);

    update(ref(db, `UpgradeRequest/${upgrade.id}`), {
      state: "deleted",
    })
      .then((result) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Card elevation={1}>
        <CardHeader
          //   avatar={<Person aria-label="recipe">R</Person>}
          title={`Phone: ${upgrade.phone}`}
          subheader={`Date: ${upgrade.time}`}
          action={
            <Typography variant="h6" color="textPrimary">
              Current :{" "}
              <span style={{ color: "green" }}>{user?.memberType}</span> Member
            </Typography>
          }
        />

        <CardContent>
          <Typography variant="h5" color="textPrimary">
            TrxId: {upgrade.trxId}
          </Typography>
          <Typography variant="h6" color="textPrimary">
            User Name: {user?.name}
          </Typography>
          <Typography variant="h6" color="textPrimary">
            User Phone: {upgrade?.id}
          </Typography>

          <Typography variant="h6" color="textPrimary">
            Request For Get{" "}
            <span style={{ color: "red" }}> {upgrade?.memberRequestType}</span>
            Membership.
          </Typography>
          <Typography variant="h6" color="textPrimary">
            Amount Sent:
            <span style={{ color: "red" }}> {upgrade?.amount}</span>.
          </Typography>

          {loading ? (
            <BeatLoader loading={loading} />
          ) : (
            <>
              {!done && (
                <Button
                  onClick={() => updateMemberShip(userType.SILVER)}
                  variant="outlined"
                >
                  Accept
                </Button>
              )}

              <Button onClick={() => cancelRequest()} variant="outlined">
                {done ? "Delete" : "Reject"}
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default UpgradeItem;
